export const INDEX = '/';
export const ALL = '*';
export const SIGNUP = '/Account/Register';
export const HOMEWILDCARD = "/Home/index/:id?";
export const HOME = "/Home/index";
export const MOVEPLANLETTER = '/MovePlanLetter/Index';
export const INVENTORY = '/Inventory/Index';
export const INVENTORYWITHKEY = '/Inventory/Index/:inventoryId';
export const INVENTORYEDIT = '/Inventory/EditInventory';
export const INVENTORYEDITWITHKEY = '/Inventory/EditInventory/:inventoryId';
export const ADDINVENTORY = '/Inventory/CreateInventory';
export const PRINTINVENTORY = '/Inventory/InventoryPrint'
export const PRINTINVENTORYWITHKEY = '/Inventory/InventoryPrint/:inventoryId'
export const CREATECUSTOMROOM = '/Inventory/CreateCustomRoom';
export const FORMS ="/Forms/Index";
export const CONTACTDETAILSVIEW = '/Contact/ContactViewDetails';
export const CONTACTDETAILSEDIT = '/Contact/ContactAcctEdit/1';
export const CREATERELOCATION ='/CreateRelocation/Index';
export const RELOCATIONREQUEST ='/RelocationRequest/Index';
export const INTRODUCTION ='/RelocationRequest/Index/Introduction';
export const ERRORGOHOME = '/RelocationRequest/Error';

export const InternationalRelocation ='/CreateRelocation/IntlRelocation';
export const CREATERELOCATION1 ='/CreateRelocation/Index/1';
export const PERSONALDETAILS = '/RelocationRequest/Index/PersonalDetails';
export const INTRODUCTIONDETAILS = '/RelocationRequest/Index/Introduction';
export const RELOCATIONDETAILS = '/RelocationRequest/Index/RelocationDetails';
export const RELOCATIONDETAILS_GOVT = '/RelocationRequest/Index/RelocationDetails_Govt';
export const HOUSING = '/RelocationRequest/Index/HousingConsideration';
export const PETDETAILS = '/RelocationRequest/Index/PetDetails';
export const TEMPORARY = '/RelocationRequest/Index/TemporaryAccommodation'
export const TRAVELDETAILS = '/RelocationRequest/Index/TravelDetails'
export const OTHERCONSIDERATION  ='/RelocationRequest/Index/OtherConsideration';
export const INVENTORYDETAILS ='/RelocationRequest/Index/Itinerary';
export const DEBITAUTHORISATION = '/RelocationRequest/Index/DebitAuthorisation';
export const DECLARATION ='/RelocationRequest/Index/Declaration';
export const SUBMITAFR = '/RelocationRequest/Index/SubmitAFR'

export const REIMBURSEMENT = '/Reimbursement/RequestReimbursement';
export const REIMBURSEMENTWITHID = '/Reimbursement/RequestReimbursement/:caseId';
export const SUBMITNOTICE = '/Notice/SubmitNotice';
export const SUBMITNOTICEROOT = '/Notice/SubmitNotice/:CaseID/:RelocationPlanServiceID/:DeliveryAddrID/:RelocationPlanID';
export const SUBMITNOTICESTEP2 = '/Notice/SubmitNoticeStep2';
export const SUBMITNOTICESTEP3 = '/Notice/SubmitNoticeStep3';
export const SUBMITNOTICERESULT = '/Notice/SubmitNoticeResult';
export const NOTICE = '/Notice/index';
export const NOTICEROOT = '/Notice/index/:NoticeId';
export const CAPTCHA = '/Account/Recover';

export const MPASSWORD = "https://passwordreset.microsoftonline.com/?username=";

